import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import useCompanySettings from "../hooks/useSettings/companySettings";
import ClassicLayout from "./ClassicLayout";
import ModernLayout from "./ModernLayout";
import BackdropLoading from "../components/BackdropLoading";
import { toast } from "react-toastify";

// Retorno do "Vincular conta Google" (backend redireciona para /tickets?googleLink=...)
const GOOGLE_LINK_MESSAGES = {
  em_uso: "Esta conta Google já está vinculada a outro usuário.",
  ja_vinculado: "Seu usuário já está vinculado a outra conta Google. Desvincule antes de trocar.",
  cancelado: "Vínculo com o Google cancelado.",
  sessao_expirada: "A tentativa de vínculo expirou ou a sessão mudou. Tente de novo.",
  email_nao_verificado: "O Google não confirmou o e-mail desta conta.",
  token: "Não foi possível validar a conta Google. Tente de novo.",
};

/**
 * LoggedInLayout - Seletor de Layout
 * 
 * Este componente verifica a configuração "layoutType" da empresa
 * e carrega o layout apropriado:
 * - "modern" = Layout moderno (navbar horizontal)
 * - "classic" = Layout clássico (menu lateral)
 * 
 * A configuração pode ser alterada em:
 * Configurações → Aparência → Tipo de Layout
 */
const LoggedInLayout = (props) => {
  const { user } = useContext(AuthContext);
  const { get: getSetting } = useCompanySettings();
  const [layoutType, setLayoutType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const result = params.get("googleLink");
    if (!result) return;
    window.history.replaceState({}, "", window.location.pathname);
    if (result === "ok") {
      toast.success("Conta Google vinculada. Você já pode usar \"Entrar com Google\".");
      return;
    }
    toast.error(GOOGLE_LINK_MESSAGES[result] || "Falha ao vincular a conta Google. Tente de novo.");
  }, []);

  useEffect(() => {
    const fetchLayoutType = async () => {
      try {
        if (user?.companyId) {
          const setting = await getSetting({
            column: "layoutType"
          });
          
          // Se encontrou a configuração, usa ela
          if (setting && setting.layoutType) {
            setLayoutType(setting.layoutType);
          } else {
            // Fallback para modern se não encontrar
            setLayoutType("modern");
          }
        } else {
          // Sem companyId, usa modern
          setLayoutType("modern");
        }
      } catch (error) {
        console.log("Erro ao buscar layoutType, usando modern:", error);
        // Em caso de erro, usa modern
        setLayoutType("modern");
      } finally {
        setLoading(false);
      }
    };

    // Pequeno delay para garantir que o contexto está carregado
    const timer = setTimeout(() => {
      fetchLayoutType();
    }, 100);

    return () => clearTimeout(timer);
  }, [user?.companyId]);

  // Mostra loading enquanto busca a configuração
  if (loading || !layoutType) {
    return <BackdropLoading />;
  }

  // Renderiza o layout apropriado
  if (layoutType === "modern") {
    return <ModernLayout {...props} />;
  }

  return <ClassicLayout {...props} />;
};

export default LoggedInLayout;
